import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RealtimeTypeDisplayPipe } from './realtime-type-display.pipe';

@NgModule({
  declarations: [RealtimeTypeDisplayPipe],
  imports: [CommonModule],
  exports: [RealtimeTypeDisplayPipe]
})
export class RealtimeTypeDisplayPipeModule {}
